import React, { useState, useEffect } from "react";
import {
  Box,
  Input,
  Button,
  Text,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/react";
import axios from "axios";

const EditAsset = ({ assetProp, onClose, onRefresh, isNew }) => {
  const [asset, setAsset] = useState({
    ip: "",
    mac_address: "",
    hostname: "",
    custom_hostname: "",
    operating_system: "",
    asset_revenue_impacted_per_outage: 0,
    days_to_restore: 0,
    business_unit_id: 0,
    communication_count: 0,
    data_volume: 0,
    insecure_protocol_sessions: 0,
    asset_criticality_score: 0.0
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (assetProp && !isNew) {
      setAsset(assetProp);
    }
    console.log("Set Asset", assetProp);
  }, [assetProp, isNew]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAsset((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    const { ip, mac_address, hostname, custom_hostname, operating_system, asset_revenue_impacted_per_outage, days_to_restore, business_unit_id, communication_count, data_volume, insecure_protocol_sessions, asset_criticality_score } = asset;

    if (!business_unit_id || !ip || !mac_address || !hostname || !custom_hostname || !operating_system || !asset_revenue_impacted_per_outage || !days_to_restore || !communication_count || !data_volume || !insecure_protocol_sessions || !asset_criticality_score) {
      setError("All fields are mandatory.");
      return;
    }

    setError("");
    let data;
    if (isNew) {
      data = {
        ip,
        mac_address,
        hostname,
        custom_hostname,
        operating_system,
        asset_revenue_impacted_per_outage: parseInt(asset_revenue_impacted_per_outage, 10),
        days_to_restore: parseInt(days_to_restore, 10),
        business_unit_id: parseInt(business_unit_id, 10),
        communication_count: parseInt(communication_count, 10),
        data_volume: parseInt(data_volume, 10),
        insecure_protocol_sessions: parseInt(insecure_protocol_sessions, 10),
        asset_criticality_score: parseFloat(asset_criticality_score),
        api_key: process.env.REACT_APP_AWS_FLASK_API_KEY,
      };
    } else {
      data = {
        _id: assetProp._id,
        updates: {
          ip,
          mac_address,
          hostname,
          custom_hostname,
          operating_system,
          asset_revenue_impacted_per_outage: parseInt(asset_revenue_impacted_per_outage, 10),
          days_to_restore: parseInt(days_to_restore, 10),
          business_unit_id: parseInt(business_unit_id, 10),
          communication_count: parseInt(communication_count, 10),
          data_volume: parseInt(data_volume, 10),
          insecure_protocol_sessions: parseInt(insecure_protocol_sessions, 10),
          asset_criticality_score: parseFloat(asset_criticality_score)
        },
        api_key: process.env.REACT_APP_AWS_FLASK_API_KEY,
      };
    }

    console.log("Create or update asset data object", data);

    const uri = process.env.REACT_APP_AWS_FLASK_BASE_URI + (isNew ? `/create_asset` : `/update_asset`);

    axios.post(uri, data)
      .then(response => {
        alert(isNew ? "Asset created successfully!" : "Asset details saved successfully!");
        onClose(); // Close the modal after saving
        onRefresh(); // Refresh the table
      })
      .catch(error => {
        console.error("There was an error saving the asset details!", error);
      });
  };

  return (
    <Box p={5}>
      <Text fontSize="2xl" mb={4}>
        {isNew ? "Create Asset" : "Edit Asset"}
      </Text>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>IP Address</FormLabel>
        <Input
          name="ip"
          value={asset.ip}
          onChange={handleChange}
        />
        {error && !asset.ip && <FormErrorMessage>IP Address is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>MAC Address</FormLabel>
        <Input
          name="mac_address"
          value={asset.mac_address}
          onChange={handleChange}
        />
        {error && !asset.mac_address && <FormErrorMessage>MAC Address is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Hostname</FormLabel>
        <Input
          name="hostname"
          value={asset.hostname}
          onChange={handleChange}
        />
        {error && !asset.hostname && <FormErrorMessage>Hostname is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Custom Hostname</FormLabel>
        <Input
          name="custom_hostname"
          value={asset.custom_hostname}
          onChange={handleChange}
        />
        {error && !asset.custom_hostname && <FormErrorMessage>Custom Hostname is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Operating System</FormLabel>
        <Input
          name="operating_system"
          value={asset.operating_system}
          onChange={handleChange}
        />
        {error && !asset.operating_system && <FormErrorMessage>Operating System is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Revenue Impacted</FormLabel>
        <Input
          name="asset_revenue_impacted_per_outage"
          value={asset.asset_revenue_impacted_per_outage}
          onChange={handleChange}
        />
        {error && !asset.asset_revenue_impacted_per_outage && <FormErrorMessage>Revenue Impacted is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Days to Restore</FormLabel>
        <Input
          name="days_to_restore"
          value={asset.days_to_restore}
          onChange={handleChange}
        />
        {error && !asset.days_to_restore && <FormErrorMessage>Days to Restore is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Business Unit ID</FormLabel>
        <Input
          name="business_unit_id"
          value={asset.business_unit_id}
          onChange={handleChange}
        />
        {error && !asset.business_unit_id && <FormErrorMessage>Business Unit ID is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Communication Count</FormLabel>
        <Input
          name="communication_count"
          value={asset.communication_count}
          onChange={handleChange}
        />
        {error && !asset.communication_count && <FormErrorMessage>Communication Count is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Data Volume</FormLabel>
        <Input
          name="data_volume"
          value={asset.data_volume}
          onChange={handleChange}
        />
        {error && !asset.data_volume && <FormErrorMessage>Data Volume is required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Insecure Protocol Sessions</FormLabel>
        <Input
          name="insecure_protocol_sessions"
          value={asset.insecure_protocol_sessions}
          onChange={handleChange}
        />
        {error && !asset.insecure_protocol_sessions && <FormErrorMessage>Insecure Protocol Sessions are required.</FormErrorMessage>}
      </FormControl>
      <FormControl mb={4} isInvalid={error}>
        <FormLabel>Asset Criticality Score</FormLabel>
        <Input
          name="asset_criticality_score"
          value={asset.asset_criticality_score}
          onChange={handleChange}
        />
        {error && !asset.asset_criticality_score && <FormErrorMessage>Asset Criticality Score is required.</FormErrorMessage>}
      </FormControl>
      <Button colorScheme="teal" onClick={handleSave}>
        {isNew ? "Create" : "Save"}
      </Button>
    </Box>
  );
};

export default EditAsset;